export default function PriceContext() {
  return (
    <section id="price-context" className="py-20 sm:py-28 bg-white" aria-labelledby="price-context-heading">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <h2 id="price-context-heading" className="text-2xl sm:text-3xl md:text-4xl font-extralight text-black mb-4 tracking-[0.08em]">
            価格改定の背景
          </h2>
          <p className="text-sm sm:text-base font-extralight text-black/50 tracking-wide max-w-2xl mx-auto">
            品質を維持しながら、持続可能な製品づくりを続けるための決断です。
          </p>
        </div>

        <div className="space-y-8 sm:space-y-10">
          <div className="bg-[#FAFAF8] rounded-2xl p-6 sm:p-8 border border-black/5">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#C4787A]/10 rounded-full flex-shrink-0">
                <i className="ri-calendar-line text-lg text-[#C4787A]" aria-hidden="true"></i>
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-light text-black mb-2 tracking-wide">
                  <strong className="font-medium">2026年3月1日</strong> より価格改定
                </h3>
                <p className="text-sm font-extralight text-black/60 leading-relaxed tracking-wide">
                  原材料費の高騰、円安の影響、そして職人の技術継承のため、やむを得ず価格を見直すことになりました。現在の価格でご提供できるのは、3月31日までのご予約分までとなります。
                </p>
              </div>
            </div>
          </div>

          <div className="bg-[#FAFAF8] rounded-2xl p-6 sm:p-8 border border-black/5">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#C4787A]/10 rounded-full flex-shrink-0">
                <i className="ri-gift-line text-lg text-[#C4787A]" aria-hidden="true"></i>
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-light text-black mb-2 tracking-wide">
                  4月の次回入荷までの<strong className="font-medium">価格維持購入予約</strong>
                </h3>
                <p className="text-sm font-extralight text-black/60 leading-relaxed tracking-wide">
                  3月31日までにご予約いただいたお客様には、現行価格でご提供いたします。さらに、感謝の気持ちを込めて、Amazonギフト券5,000円分をプレゼント。新生活を応援します。
                </p>
              </div>
            </div>
          </div>

          <div className="bg-[#FAFAF8] rounded-2xl p-6 sm:p-8 border border-black/5">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#C4787A]/10 rounded-full flex-shrink-0">
                <i className="ri-heart-line text-lg text-[#C4787A]" aria-hidden="true"></i>
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-light text-black mb-2 tracking-wide">
                  <strong className="font-medium">品質へのこだわり</strong>は変わりません
                </h3>
                <p className="text-sm font-extralight text-black/60 leading-relaxed tracking-wide">
                  価格は変わりますが、MeVERの製品づくりへの姿勢は変わりません。一つひとつ丁寧に、長く使える製品を作り続けます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
